'use client';

import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import Portal from '../../components/portal';

type PortalSection = 'discover' | 'wikis' | 'updates' | 'characters';

function sectionFromPath(pathname: string): PortalSection {
  if (pathname === '/wikis' || pathname.startsWith('/wikis/')) return 'wikis';
  if (pathname === '/updates' || pathname.startsWith('/updates/')) return 'updates';
  if (pathname === '/characters' || pathname.startsWith('/characters/')) {
    return 'characters';
  }
  return 'discover';
}

/**
 * SPA 门户：`/` / `/wikis` / `/updates` / `/characters` / `/legacy-home`，复用 Portal。
 * 爬虫仍走 app SSR / snapshot。
 */
export default function SpaPortalPage() {
  const { pathname } = useLocation();
  const section = useMemo(() => sectionFromPath(pathname), [pathname]);
  return <Portal section={section} />;
}
